<script>
import ModelCreateModal from './modal-create';
import FormsModel from "@/components/forms/jala-pond";

export default {
  extends: ModelCreateModal,
  props: {
    modalTitle: {default() { return this.lodash.startCase(this.$t('jala_ponds.singular')) }},
    resourceRoute: {default: 'jala_ponds'},
    modelVariable: {default: 'pond'},
    form: {default() { return FormsModel; }}
  },
  methods: {
    store(value) {
      return this.$axios.post('/jala/ponds', value);
    }
  },
}
</script>
